import { TelemetryOptions } from "./TelemetryOptions";

const options = {
    reportErrors: true
};

export function getDefaultTelemetryOptions(): TelemetryOptions {
    return options;
}
